import { SvelteMap } from 'svelte/reactivity';
import type { ReframeMarker } from '@core/rf-observer/rf-marker.svelte';
import { writable } from 'svelte/store';

export let RFMarkerOrderId = writable(0);
export const updateMarkerOrderId = (): void => {
	RFMarkerOrderId.update((id) => id + 1);
};

export const markers: SvelteMap<string, ReframeMarker> = $state(new SvelteMap());
export const addMarker = (id: string, marker: ReframeMarker): void => {
	markers.set(id, marker);
};

export const markerStore = {
	markers: {
		get items() {
			return [...markers];
		},
		addMarker,
		updateMarkerOrderId,
	},
};
